import React from 'react';
type SectionHeadingProps = {
  eyebrow?: string;
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  center?: boolean;
};
export function SectionHeading({
  eyebrow,
  title,
  subtitle,
  center = true
}: SectionHeadingProps) {
  return <div className={center ? 'mx-auto max-w-2xl text-center' : 'max-w-2xl'} data-id="element-165">
      {eyebrow && <p className="mb-3 text-sm font-semibold uppercase tracking-[0.18em] text-brand" data-id="element-166">
          {eyebrow}
        </p>}
      <h2 className="font-display text-3xl font-black leading-tight text-ink sm:text-4xl md:text-[2.75rem]" data-id="element-167">
        {title}
      </h2>
      {subtitle && <p className="mt-4 text-base leading-relaxed text-ink/60 sm:text-lg" data-id="element-168">
          {subtitle}
        </p>}
    </div>;
}